module.exports = __webpack_public_path__ + "cff186bc591cdd14ffc02d16d4684542.png";